import { useQueryClient } from "@tanstack/react-query";
import useKlydoMutation, {
  UseKlydoMutationOptions,
} from "../../../../components/hooks/useKlydoMutation";
import adminApiClient from "../../../../api/admin";

export type SetUserPropertiesInput = {
  userId: string;
  b2b: boolean;
};

const useSetUserPropertiesMutation = (
  options?: UseKlydoMutationOptions<{ b2b: boolean }, SetUserPropertiesInput>,
) => {
  const queryClient = useQueryClient();
  return useKlydoMutation({
    mutationKey: ["set-user-properties"],
    mutationFn: ({ userId, b2b }: SetUserPropertiesInput) =>
      adminApiClient.setUserProperties(userId, b2b),
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({
        queryKey: ["userProperties", variables.userId],
      });
      options?.onSuccess?.(data, variables, context);
    },
  });
};

export default useSetUserPropertiesMutation;
